import dayjs from 'dayjs';
import flatten from 'lodash/flatten';
import IconChats from '@/assets/icons/calendar.svg';
import MiniStat from '@/components/mini_stat/MiniStat';
import AnalyticService from '@/api/analytic';
import LoadingDots from '@/components/loading_dot/LoadingDot.vue';

export default {
  name: 'DashboardDash',
  components: {
    IconChats,
    MiniStat,
    LoadingDots
  },

  data: function() {
    const dateFormat = 'YYYY-MM-DD';
    const now = dayjs();
    return {
      fromDate: now.subtract(7, 'day').format(dateFormat),
      toDate: now.format(dateFormat),
      isLoading: true,
      items: this.formatItems(placeholder)
    };
  },

  created: function() {
    this.getAnalytic();
  },

  methods: {
    formatDates(fromDate, toDate) {
      const dateFormat = 'YYYY/MM/DD';
      const formattedFrom = dayjs(fromDate).format(dateFormat);
      const formattedTo = dayjs(toDate).format(dateFormat);

      return `${formattedFrom} — ${formattedTo}`;
    },

    formatItems(dictionary) {
      const sections = Object.keys(dictionary).map(section => {
        let total = 0;
        const rows = Object.keys(dictionary[section]).map(language => {
          const label = `${labels[section]} — ${language}`;
          const value = dictionary[section][language];
          total += value;
          return { label, value };
        });
        const totalRow = {
          label: `${labels[section]} — total`,
          value: total
        };
        return [totalRow, ...rows];
      });
      return flatten(sections);
    },

    async getAnalytic() {
      this.isLoading = true;

      const { fromDate: since, toDate: until } = this;
      const result = await AnalyticService.getAnalytic({ since, until });
      this.items = this.formatItems(result);

      this.isLoading = false;
    }
  }
};

const labels = {
  signUp: 'Sign Up',
  rewardTotal: 'Total Reward',
  rewardUniqueUser: 'UU Reward',
  lastActive: 'Last Active'
};

const languages = { enUS: 0, zhTW: 0, zhCN: 0 };

const placeholder = {
  signUp: languages,
  rewardTotal: languages,
  rewardUniqueUser: languages,
  lastActive: languages
};
